import React from 'react';
import { Box } from '@mui/material';

const Docs = () => {
  return (
    <Box sx={{ width: '100%', height: '100vh' }}>
      <iframe src="https://akamalov.notion.site/ebd/18327bcc97fa801baf95ec82f2e1f314" width="100%" height="100%" frameBorder="0" allowFullScreen />
    </Box>
  );
};

export default Docs;
